import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiResponse } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { Division, DivisionRequest } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { CamService } from 'src/app/services/camService/cam.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { CompanyManagementContentService } from "src/app/modules/cam/services/company-management-content.service";
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";

@Component({
    selector: 'app-edit-division-dialog',
    templateUrl: './edit-division-dialog.component.html',
    styleUrls: ['./edit-division-dialog.component.scss'],
    imports: [ReactiveFormsModule, MatIconButton, MatIcon, MatFormField, MatLabel, MatInput, NgIf, MatError, MatRadioGroup, MatRadioButton, MatButton]
})
export class EditDivisionDialogComponent implements OnInit {
    content: any;
    manageCompanyContent: any;
  editDivisionDetailForm: FormGroup | any
  tableData: Division[] = [];


  constructor(private readonly bookingContentService: BookingContentService, private readonly companyManagementContentService: CompanyManagementContentService, private dialogRef: MatDialogRef<EditDivisionDialogComponent>, private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any, private _camService: CamService, private router: Router, private _ToastrApiService: ToastrApiService, private _CompanyManagementService: CompanyManagementService
  ) {

    console.log(data)

    this.editDivisionDetailForm = this.fb.group({
      division: [data?.nameOfDivision || '', Validators.required],
      status: [data?.status, Validators.required]

    })

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.tableData = this.data.tabledata
    console.log(this.tableData)
      this.companyManagementContentService.content$.subscribe((res: any) => { this.manageCompanyContent = res; });
      this.bookingContentService.content$.subscribe((res: any) => { this.content = { ...(this.content || {}), ...(res || {}) }; });
  }

  getDivisionList() {
    this._camService.GetDivisionDetails().then((res: any) => {
      this.tableData = res.data || [];
    });
  }


  onCancel(): void {
    this.dialogRef.close(); // Close dialog without result
  }


  onSave() {

          this._CompanyManagementService.company_management_divisionDetailPOPUP('Save')//GTM use


    if (this.editDivisionDetailForm.invalid) {
      return
    }

    const division: DivisionRequest = {
      flag: 'UPDATE',
      nameOfDivision: this.editDivisionDetailForm.value.division.trim(),
      divisionId: this.data.BusinessTypeID,
      status: this.editDivisionDetailForm.value.status
    };
    const businessTypeId = this.data.BusinessTypeID

    this._camService.InsertDivisionDetailsV1(division).then(($res: ApiResponse<boolean>) => {

      if ($res.status == "Success") {
        this.dialogRef.close();
        this.getDivisionList();
        this._ToastrApiService.show('success', $res.message);
          this._CompanyManagementService.save_success('Division details','Success')//GTM use

        this.dialogRef.close(true);
      }

    }).catch((error: any) => {
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while updating the Division. Please try again later.';
      this._ToastrApiService.show('error', errorMessage);
    })
  }


  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }



}


